module.exports = __webpack_public_path__ + "img/oldmail-01.13510c60.png";